import { app } from '@/main'
import * as dayjs from 'dayjs'
import * as Sentry from '@sentry/vue'

// mutations
import audienceId from '@/store/mutations/audienceId'
import slideOptions from '@/store/mutations/slideOptions'
import slides from '@/store/mutations/slides'
import currentUser from '@/store/mutations/currentUser'
import presentation from '@/store/mutations/presentation'
import attendedPresentation from '@/store/mutations/attendedPresentation'
import common from '@/store/mutations/common'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...currentUser,
  ...presentation,
  ...attendedPresentation,
  ...common,

  setLang: (state, payload) => {
    app.$i18n.locale = payload
    dayjs.locale(payload)
  },

  setSlide: (state, payload) => {
    if (state.slide.id !== payload.id) {
      state.slide = payload
    }
  },

  updateSlide: (state, payload) => {
    if (state.slide.quizStatus === 4 && payload.quizStatus === 1 && state.slide.id === payload.id) {
      Sentry.captureException('slide.mutation:updateQuizStatus from question screen to lobby screen', {
        extra: {
          currentSlide: state.slide,
          updatedSlide: payload,
        },
      })
    }
    state.slide = { ...state.slide, ...payload }
  },

  setPresentation: (state, payload) => {
    state.presentation.id = null
    state.presentation = payload
  },

  patchPresentation: (state, payload) => {
    state.presentation = { ...state.presentation, ...payload }
  },

  setConnectionError: (state, payload) => {
    state.connectionError = payload
  },

  setUserLoaded: (state, payload) => {
    state.userLoaded = payload
  },

  setIsLoadingCurrentUser: (state, payload) => {
    state.isLoadingCurrentUser = payload
  },
}
